import { BASE_URL } from "../config/api";
import { jwtDecode } from "jwt-decode";

// Helper to get user email for logging
const getUserEmailForLogging = async () => {
  try {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      const user = await fetchUserById(decoded.id);
      return user.user_email;
    }
  } catch (error) {
    console.error("Error getting user email for logging:", error);
  }
  return "unknown";
};

export const createActivity = async (formData) => {
  const token = localStorage.getItem("token");
  await getUserEmailForLogging();

  const response = await fetch(`${BASE_URL}/activity/createActivity`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to create Activity");
  }

  return await response.json();
};

export const updateActivity = async (id, formData) => {
  const token = localStorage.getItem("token");
  await getUserEmailForLogging();

  const response = await fetch(`${BASE_URL}/activity/updateActivity/${id}`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || "Failed to update event");
  }

  return await response.json();
};

export const fetchAllActivities = async () => {
  const response = await fetch(`${BASE_URL}/activity/fetchAllActivities`);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const data = await response.json();
  return data.data || [];
};

export const fetchAllActivitiesWithUsers = async () => {
  try {
    const activities = await fetchAllActivities();

    const activityWithUserData = await Promise.all(
      activities.map(async (activity) => {
        try {
          const token = localStorage.getItem("token");
          const userRes = await fetch(
            `${BASE_URL}/user/fetchUserById/${activity.user_id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          if (!userRes.ok) throw new Error("Failed to fetch user");

          const userData = await userRes.json();

          return {
            ...activity,
            userName: userData.user?.user_name || "Unknown",
            userDesignation: userData.user?.user_designation || "Not Available",
            userImage: userData.user?.user_profile_img || "default.png",
          };
        } catch {
          return {
            ...activity,
            userName: "Unknown",
            userRole: "Not Available",
            userImage: "default.png",
          };
        }
      })
    );

    return activityWithUserData;
  } catch (error) {
    throw new Error(error.message || "Failed to fetch activity with users");
  }
};

export const fetchActivityById = async (id) => {
  const response = await fetch(`${BASE_URL}/activity/fetchActivityById/${id}`);
  if (!response.ok) {
    throw new Error("Failed to fetch activity");
  }
  return await response.json();
};

export const fetchUserById = async (id) => {
  const response = await fetch(`${BASE_URL}/user/fetchUserById/${id}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || "Failed to fetch user");
  }

  const data = await response.json();
  return data.user;
};

export const fetchActivitiesByDepartment = async (deptId) => {
  try {
    const response = await fetch(
      `${BASE_URL}/activity/fetchActivitiesByDepartment/${deptId}`
    );
    if (!response.ok) throw new Error("Failed to fetch activities");

    const { data: activities } = await response.json();

    const activityWithUserData = await Promise.all(
      activities.map(async (activity) => {
        try {
          const token = localStorage.getItem("token");
          const userRes = await fetch(
            `${BASE_URL}/user/fetchUserById/${activity.user_id}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          if (!userRes.ok) throw new Error("Failed to fetch user");

          const userData = await userRes.json();

          return {
            ...activity,
            userName: userData.user?.user_name || "Unknown",
            userDesignation:
              userData.user?.user_designation || "Not Available",
            userImage: userData.user?.user_profile_img || "default.png",
          };
        } catch {
          return {
            ...activity,
            userName: "Unknown",
            userDesignation: "Not Available",
            userImage: "default.png",
          };
        }
      })
    );

    return activityWithUserData;
  } catch (error) {
    throw new Error(error.message || "Failed to fetch activities by department");
  }
};
